import React from 'react';

const httpExpection = (e) => {
    if (e.status === 401) {
        window.location.href = '/authentication/sign-in'
    } 
}

export default httpExpection;